"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldTypes = exports.singleAnswerFieldTypes = exports.multipleAnswerFieldTypes = void 0;
exports.multipleAnswerFieldTypes = ["checkbox", "table"];
exports.singleAnswerFieldTypes = [
    "number",
    "section",
    "radiobutton",
    "dropdown",
    "nric",
    "email",
    "rating",
    "yes_no",
    "decimal",
    "textfield",
    "textarea",
    "attachment",
    "date",
    "mobile",
    "homeno",
];
exports.fieldTypes = [...exports.multipleAnswerFieldTypes, ...exports.singleAnswerFieldTypes];
//# sourceMappingURL=typings.js.map